import { render } from "./ImageZoom.vue?vue&type=template&id=5e9fd08d"
import script from "./ImageZoom.vue?vue&type=script&lang=ts"
export * from "./ImageZoom.vue?vue&type=script&lang=ts"
script.render = render

export default script